<template>
  <nuxt-link :class="[{ 'child-active': isChildPage }]" v-bind="props">
    {{ label }}
  </nuxt-link>
</template>
<script lang="ts" setup>
import type { RouteLocationRaw } from 'vue-router';
import type { NuxtLinkProps } from '#app';

interface ButtonNavProps extends NuxtLinkProps {
  label: string;
  src: string;
  sections: string[];
  to?: string | RouteLocationRaw;
  colorize?: boolean;
}
const props = defineProps({
  label: null,
  src: null,
  sections: null,
  to: null,
  colorize: { type: Boolean, default: true }
});

const route = useRoute();

const isChildPage = computed(() => {
  return (
    props.sections.filter((section) => {
      if (section === '') {
        return route.path === '/';
      } else {
        return route.path.indexOf(`/${section}`) === 0;
      }
    }).length > 0
  );
});
</script>
<style lang="scss" scoped>
a {
  display: inline-flex;
  position: relative;
  align-items: center;
  width: fit-content;
  color: var(--color_secondary_darker);
  text-align: center;
  @include font('n', 400, 'secondary');

  &::after {
    content: '';
    display: block;
    position: absolute;
    bottom: -0.8rem;
    left: 0;
    width: 100%;
    height: 0.2rem;
    transform: scaleX(0);
    transition: transform 200ms $ease-in-quad;
    background-color: var(--color_secondary);
  }

  &:hover,
  &.router-link-active,
  &.router-link-exact-active,
  &.child-active,
  &:focus {
    color: var(--color_secondary);
    &::after {
      transform: scaleX(1);
      transition: transform 200ms $ease-out-quad;
    }
  }
}
</style>
